import React, { useRef, useEffect, useState } from 'react';
import { SheetData } from './stolarz_form_types';
// import { useFormContext } from 'react-hook-form';

const thickLine = 7;
const thinLine = 2;

const marigin = 3;

const Canvas = ({ sheet, height, width, optionsEdges, field, parametrizeName }: {
  sheet: SheetData, height: number, width: number,
  optionsEdges: { value: string; label: string }[],
  field: any | SheetData,
  parametrizeName: string,
}) => {
  // const { watch, formState: { errors }, register, control } = useFormContext<FormData>();
  const canvasRef = useRef<HTMLCanvasElement>(null);
  // const [isHovered, setHover] = useState<boolean>(false);
  // const [isOnButton, setOnButton] = useState<boolean>(false);
  // const isOnButtonRef = useRef<boolean>(false);
  const [canvasY, setCanvasY] = useState<number>(height); // automatically reduce height of canvas to gain space
  // const [posX, setPosX] = useState<number>(0);
  // const [posY, setPosY] = useState<number>(0);

  // function recordCanvasPosition() {
  //   if (canvasRef.current) {
  //     const canvas = canvasRef.current;
  //     const boundingBox = canvas.getBoundingClientRect();
  //     setPosX(boundingBox.x);
  //     setPosY(boundingBox.y);
  //   }
  // };
  // useEffect(() => {
  //   window.addEventListener('resize', () => recordCanvasPosition());
  //   window.addEventListener('scroll', () => recordCanvasPosition());
  //   return () => {
  //     window.removeEventListener('resize', recordCanvasPosition);
  //   };
  // }, []);

  useEffect(() => {
    if (canvasRef.current) {
      const canvas = canvasRef.current;
      // recordCanvasPosition();
      const context = canvas.getContext('2d');
      if (context == null) throw new Error('Could not get canvas context');
      context.clearRect(0, 0, canvas.clientWidth, canvas.clientHeight);

      const mnoznik = Math.min(width - marigin - 10, height - marigin - 10) / (Math.max(sheet.length, sheet.width))
      const normalizedLength = sheet.length * mnoznik; // todo ugh, the naming...
      const normalizedWidth = sheet.width * mnoznik;
      const ratio = normalizedLength / normalizedWidth;
      setCanvasY(normalizedWidth + marigin * 2);
      // context.font = "42px" // todo does not work?
      context.lineWidth = 1;
      context.strokeStyle = "black"
      let compensationY = 5;
      if (ratio > 0.5 && ratio < 1.5) {
        context.strokeText("Sz", 20 - 9, marigin + normalizedWidth / 2);
        context.strokeText("Dł", marigin + normalizedLength / 2 - 4, 20);
      } else {
        compensationY = 2;
      }
      context.lineWidth = 2;
      if (sheet.useGrain) {
        context.strokeText("--≻", marigin + normalizedLength / 2 - 8, marigin + normalizedWidth / 2 + compensationY);
        context.strokeText("--≻", marigin + normalizedLength / 2 - 8 + 8, marigin + normalizedWidth / 2 + compensationY);
        // different styles: --> --→ --≻ -->
      }
      {
        const edge = sheet.edgeDown
        context.lineWidth = edge.edgeCode === "" ? thinLine : thickLine;
        context.beginPath();
        context.moveTo(marigin, marigin + normalizedWidth);
        context.lineTo(marigin + normalizedLength, marigin + normalizedWidth);
        context.stroke();
      }
      {
        const edge = sheet.edgeUp
        context.lineWidth = edge.edgeCode === "" ? thinLine : thickLine;
        context.beginPath();
        context.moveTo(marigin, marigin);
        context.lineTo(marigin + normalizedLength, marigin);
        context.stroke();
      }
      {
        const edge = sheet.edgeLeft
        context.lineWidth = edge.edgeCode === "" ? thinLine : thickLine;
        context.beginPath();
        context.moveTo(marigin, marigin);
        context.lineTo(marigin, marigin + normalizedWidth);
        context.stroke();
      }
      {
        const edge = sheet.edgeRight
        context.lineWidth = edge.edgeCode === "" ? thinLine : thickLine;
        context.beginPath();
        context.moveTo(marigin + normalizedLength, marigin);
        context.lineTo(marigin + normalizedLength, marigin + normalizedWidth);
        context.stroke();
      }

    }
  }, [sheet.edgeDown.edgeCode, sheet.edgeUp.edgeCode, sheet.edgeLeft.edgeCode, sheet.edgeRight.edgeCode, sheet.width, sheet.length, sheet.useGrain, canvasY, width, height, sheet.edgeDown, sheet.edgeUp, sheet.edgeLeft, sheet.edgeRight]);


  // const productIndex = 0;
  // const index = 0;

  // const edgeCode = `${parametrizeName}.edgeCode`
  // const field_orig = field;

  // interesting colors for PCV https://codesandbox.io/s/codesandboxer-example-forked-jsvdyl?file=/example.tsx
  return <>
    <canvas ref={canvasRef} height={canvasY} width={width}
    // onMouseOver={() => setHover(true)}
    // onMouseOut={() => setHover(true || isOnButtonRef.current)} // todo this button checking is causing a flash (state transition)
    />
    {/* { true && (<>
      <Controller
        key={edgeCode + field.id}
        control={control}
        defaultValue={defaultEdge.value}
        name={edgeCode}
        render={({ formState, fieldState, field }) => (
          <div
            style={{
              position: "fixed",
              top: posY,
              left: posX,
            }}
            onMouseOver={() => { setOnButton(true); isOnButtonRef.current = true }}
            // onMouseOut={() => { setOnButton(false); isOnButtonRef.current = false }}
            onFocus={() => { setOnButton(true); isOnButtonRef.current = true }}
            onAbort={() => { setOnButton(false); isOnButtonRef.current = false }}
          // onAbort={}
          >
            <Select
              key={edgeCode + "select" + field_orig.id}
              defaultValue={defaultEdge}
              options={optionsEdges}
              value={optionsEdges.find(c => c.value === field.value)}
              onChange={val => field.onChange(val?.value)}
              onBlur={() => { setOnButton(false); isOnButtonRef.current = false }}
            // styles={}
            /></div>
        )}
      />
    </>
    )} */}
  </>;
};



export default Canvas;